import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { Point, subtract, sum } from '../../store/algebrics';

const ScrollContainer = styled.div`
  width: 100%;
  overflow: hidden;
`;

const Content = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const ScrollableContent = ({
  children,
  height = 0,
  width = 0,
  scale = 1,
}: any) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [isDragging, setIsDragging] = useState(false);
  const [position, setPosition] = useState<Point>({ x: 0, y: 0 });
  const [clientPosition, setClientPosition] = useState<Point>({ x: 0, y: 0 });
  const panEnabled = scale > 1;

  useEffect(() => {
    const newPosition = position;
    const maxX = Math.abs(width - width * scale) / 2;
    const maxY = Math.abs(height - height * scale) / 2;
    const x =
      Math.abs(newPosition.x) < maxX
        ? newPosition.x
        : Math.sign(newPosition.x) * maxX;
    const y =
      Math.abs(newPosition.y) < maxY
        ? newPosition.y
        : Math.sign(newPosition.y) * maxY;
    setPosition({ x, y });
  }, [scale]);

  const handleMouseDown = (
    client: React.MouseEvent<HTMLDivElement, MouseEvent>,
  ) => {
    if (panEnabled) {
      setIsDragging(true);
      const { clientX, clientY } = client;
      setClientPosition({ x: clientX, y: clientY });
    }
  };

  const handleMouseUp = (client: MouseEvent) => {
    if (panEnabled) {
      setIsDragging(false);
    }
  };

  const handleMouseMove = (client: MouseEvent) => {
    if (isDragging && panEnabled) {
      const finalProsition = { x: client.clientX, y: client.clientY };
      const newPosition = sum(
        position,
        subtract(finalProsition, clientPosition),
      );
      const maxX = Math.abs(width - width * scale) / 2;
      const maxY = Math.abs(height - height * scale) / 2;
      const x =
        Math.abs(newPosition.x) < maxX
          ? newPosition.x
          : Math.sign(newPosition.x) * maxX;
      const y =
        Math.abs(newPosition.y) < maxY
          ? newPosition.y
          : Math.sign(newPosition.y) * maxY;
      setPosition({ x, y });
    }
  };

  useEffect(() => {
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging]);

  return (
    <ScrollContainer>
      <Content
        ref={contentRef}
        onMouseDown={handleMouseDown}
        style={{
          transform: `matrix(1, 0, 0, 1, ${position.x}, ${position.y})`,
          cursor: scale > 1 ? 'move' : 'default',
        }}
      >
        {children}
      </Content>
    </ScrollContainer>
  );
};

export default ScrollableContent;
